import axios from '@axios'
import { DeviceStore } from '@/app/devices/state'
import { deviceModel } from '@/app/devices/model/device.model'

export default {
  namespaced: true,
  state:() => ({
    root:null,
    loadings:0,
    readOnly:false,
    id:null,
    customer_id:null,
    customerOptions:[],
    contract_id:null,
    contractOptions:[],
    technician_id:null,
    technicianOptions:[],
    datetime:null,
    product_type:null,
    product_subtype:null,
    has_pto:false,
    unique_id:null,
    sim_id:null,
    vehicle_category:null,
    vehicleCategoryOptions:[],
    plate_number:null,
    plate_right_letter:null,
    plate_middle_letter:null,
    plate_left_letter:null,
    errors:[]
  }),
  mutations:{
    updateRoot(state, payload){
      state.root = payload
    },
    startLoadingState(state){
      state.loadings += 1;
    },
    stopLoadingState(state){
      state.loadings -= 1;
    },
    activateReadOnlyMode(state){
      state.readOnly = true
    },
    updateId(state, payload){
      state.id = payload.value
    },
    updateCustomerId(state, payload){
      state.customer_id = payload.value
    },
    updateCustomerOptions(state, payload){
      state.customerOptions = payload
    },
    updateContractId(state, payload){
      state.contract_id = payload.value
    },
    updateContractOptions(state, payload){
      state.contractOptions = payload
    },
    updateTechnicianId(state, payload){
      state.technician_id = payload.value
    },
    updateTechnicianOptions(state, payload){
      state.technicianOptions = payload
    },
    updateDatetime(state, payload){
      state.datetime = payload.value
    },
    updateProductType(state, payload){
      state.product_type = payload.value
    },
    updateProductSubtype(state, payload){
      state.product_subtype = payload.value
    },
    resetProductSubtype(state){
      state.product_subtype = null;
    },
    updateHasPto(state, payload){
      state.has_pto = payload.value
    },
    updateUniqueId(state, payload){
      state.unique_id = payload.value
    },
    updateSimId(state, payload){
      state.sim_id = payload.value
    },
    updateVehicleCategory(state, payload){
      state.vehicle_category = payload.value
    },
    updateVehicleCategoryOptions(state, payload){
      state.vehicleCategoryOptions = payload
    },
    updatePlateNumber(state, payload){
      state.plate_number = payload.value
    },
    updatePlateRightLetter(state, payload){
      state.plate_right_letter = payload.value
    },
    updatePlateMiddleLetter(state, payload){
      state.plate_middle_letter = payload.value
    },
    updatePlateLeftLetter(state, payload){
      state.plate_left_letter = payload.value
    },
    updateErrors(state, payload){
      state.errors = payload
    }
  },
  actions: {
    create({ getters, commit }){
      commit('startLoadingState')
      axios.post('fieldServices', { 
        service_type: 'installation',
        ...(getters.fields.includes('technician_id') && {technician_id: getters.technician_id}),
        ...(getters.fields.includes('customer_id') && {customer_id: getters.customer_id}),
        ...(getters.fields.includes('contract_id') && {contract_id: getters.contract_id}),
        ...(getters.fields.includes('technician_id') && {technician_id: getters.technician_id}),
        ...(getters.fields.includes('datetime') && {datetime: getters.datetime}),
        ...(getters.fields.includes('product_type') && {product_type: getters.product_type}),
        ...(getters.fields.includes('product_subtype') && {product_subtype: getters.product_subtype}),
        ...(getters.fields.includes('has_pto') && {has_pto: getters.has_pto}),
        ...(getters.fields.includes('unique_id') && {unique_id: getters.unique_id}),
        ...(getters.fields.includes('sim_id') && {sim_id: getters.sim_id}),
        ...(getters.fields.includes('vehicle_category') && {vehicle_category: getters.vehicle_category}),
        ...(getters.fields.includes('plate_number') && {plate_number: getters.plate_number}),
        ...(getters.fields.includes('plate_right_letter') && {plate_right_letter: getters.plate_right_letter}),
        ...(getters.fields.includes('plate_middle_letter') && {plate_middle_letter: getters.plate_middle_letter}),
        ...(getters.fields.includes('plate_left_letter') && {plate_left_letter: getters.plate_left_letter}),
      })
      .then(response => {
        getters.root.$bvToast.toast(
          getters.root.$i18n.t('FIELD_SERVICES_INSTALLATION_CREATION_SUCCESS_MESSAGE'), {
            variant: 'success',
        })
        getters.root.$router.push({ name: 'fieldServices.installation.show', params: { id: response.data.data.id } })
      })
      .catch( reason => {
        getters.root.$bvToast.toast(
          getters.root.$i18n.t('FIELD_SERVICES_INSTALLATION_CREATION_FAILURE_MESSAGE'), {
            variant: 'danger',
        })
        commit('updateErrors' , reason.response.data.errors)
      })
      .finally(() => commit('stopLoadingState'))
    },
    fetchOptions({ dispatch }){
      dispatch('fetchCustomerOptions')
      dispatch('fetchContractOptions')
      dispatch('fetchTechnicianOptions')
      dispatch('fetchVehicleCategoryOptions')
    },
    fetchCustomerOptions({ commit }){
      commit('startLoadingState')
      axios.get('fieldServices/getCustomers')
      .then(r => {
          commit('updateCustomerOptions', r.data.data)
      })
      .catch( error => {
        getters.root.$bvToast.toast(
          getters.root.$i18n.t('FIELD_SERVICES_CUSTOMER_OPTIONS_FAILURE_MESSAGE'), {
            variant: 'danger',
        })
      })
      .finally(() => commit('stopLoadingState'))
    },
    fetchContractOptions({ commit, rootGetters }){
      commit('startLoadingState')
      axios.get('fieldServices/getContracts')
      .then(r => {
          commit('updateContractOptions', r.data.data)
      })
      .catch(error => {
        getters.root.$bvToast.toast(
          getters.root.$i18n.t('FIELD_SERVICES_CONTRACT_OPTIONS_FAILURE_MESSAGE'), {
            variant: 'danger',
        })
      })
      .finally(() => commit('stopLoadingState'))
    },
    fetchTechnicianOptions({ commit }){
      commit('startLoadingState')
      axios.get('fieldServices/getTechnicians')
      .then(r => {
          commit('updateTechnicianOptions', r.data.data)
      })
      .catch(error => {
        getters.root.$bvToast.toast(
          getters.root.$i18n.t('FIELD_SERVICES_TECHNICIAN_OPTIONS_FAILURE_MESSAGE'), {
            variant: 'danger',
        })
      })
      .finally(() => commit('stopLoadingState'))
    },
    fetchVehicleCategoryOptions({ commit }){
      commit('startLoadingState')
      axios.get('fieldServices/getCategories')
      .then(r => {
          commit('updateVehicleCategoryOptions', r.data.data)
      })
      .catch(error => {
        getters.root.$bvToast.toast(
          getters.root.$i18n.t('FIELD_SERVICES_VEHICLE_CATEGORY_OPTIONS_FAILURE_MESSAGE'), {
            variant: 'danger',
        })
      })
      .finally(() => commit('stopLoadingState'))
    },
    load({ commit, getters }, payload){
      commit('startLoadingState')
      axios.get(`fieldServices/${payload.id}`)
      .then(response => {
          if(response.data.service.service_type === 'installation'){

            const ignored = ['service_type','data']

            Object.keys(response.data.service).filter((key)=> ! ignored.includes(key)).map((key)=> {
              commit(`update${key.split('_').map((word)=> word.charAt(0).toUpperCase() + word.slice(1)).join('')}`, {value:response.data.service[key]})
            })

            Object.keys(response.data.service.data).filter((key)=> ! ignored.includes(key)).map((key)=> {
              commit(`update${key.split('_').map((word)=> word.charAt(0).toUpperCase() + word.slice(1)).join('')}`, {value:response.data.service.data[key]})
            })

            commit('stopLoadingState')
          }
      })
      .catch(error => {
        getters.root.$bvToast.toast(
          getters.root.$i18n.t('FIELD_SERVICES_LOAD_FAILURE_MESSAGE'), {
            variant: 'danger',
        })
      })
    },
    loadFromRoute({ getters, dispatch }){
      dispatch('load', {id:getters.root.$router.currentRoute.params.id})
    },
    createDevice({ getters }){

      if(!getters.root.$store.hasModule('device')){
        getters.root.$store.registerModule('device', DeviceStore)
      }

      let data = {...deviceModel}
      data.name = `PL-${getters.plate_number}`
      data.uniqueid = getters.unique_id
      data.owner_id = getters.customer_id
      data.category = getters.vehicle_category
      data.contract_id = getters.contract_id
      data.plate_number = getters.plate_number
      data.plate_right = getters.plate_right_letter
      data.plate_middle = getters.plate_middle_letter
      data.plate_left = getters.plate_left_letter

      getters.root.$store.commit('device/SET_DEVICE_DATA' , data)
      getters.root.$store.dispatch('device/fetchTypesByCategory' , getters.vehicle_category)

      getters.root.$router.push({name:'devices.create'})

    }
  },
  getters:{
    root(state){
      return state.root
    },
    isLoading(state){
      return state.loadings > 0
    },
    isReadOnly(state){
      return state.readOnly
    },
    fields(state){

      const defaultFields = [
        'customer_id',
        'contract_id',
        'technician_id',
        'datetime',
        'product_type',
        'vehicle_category',
        'plate_number',
        'plate_right_letter',
        'plate_middle_letter',
        'plate_left_letter'
      ]

      switch(state.product_type){
        case 'GPS_DEVICE' : return [...defaultFields , ...['product_subtype','has_pto','unique_id','sim_id']]
        case 'RFID_DEVICE' : return [...defaultFields , ...['product_subtype','unique_id','sim_id']]
        case 'WEIGHT_SENSOR' : return [...defaultFields , ...['product_subtype']]
        default : return defaultFields
      }

    },
    errors(state){
      return state.errors
    },
    customer_id(state){
      return state.customer_id
    },
    customerOptions(state){
      return state.customerOptions
    },
    contract_id(state){
      return state.contract_id
    },
    contractOptions(state){
      return state.contractOptions
    },
    technician_id(state){
      return state.technician_id
    },
    technicianOptions(state){
      return state.technicianOptions
    },
    datetime(state){
      return state.datetime
    },
    datetimeConfig(){
      return {
        enableTime: true,
        enableSeconds:true,
        maxDate: 'today',
        time_24hr: true,
        dateFormat: 'Y-m-d H:i:S',
        onChange: function(rawdate, altdate, FPOBJ) {
          FPOBJ.close();
          FPOBJ._input.blur();
        }
      }
    },
    product_type(state){
      return state.product_type
    },
    productTypeOptions(state, getters){
      return ['GPS_DEVICE', 'RFID_DEVICE', 'WEIGHT_SENSOR']
    },
    product_subtype(state){
      return state.product_subtype
    },
    productSubtypeOptions(state){
      switch(state.product_type){
        case 'GPS_DEVICE' : return ['Teltonika_FMB120','Teltonika_FMC130', 'Teltonika_FMB920', 'Teltonika_FMB125' ,'CalAmp_LMU330']
        case 'RFID_DEVICE' : return ['Syncotek','Impinj','Aerospace']
        case 'WEIGHT_SENSOR' : return ['Axle_leaf_suspension_sensor','Air_suspension_sensor']
        default : return []
      }
    },
    has_pto(state){
      return state.has_pto
    },
    unique_id(state){
      return state.unique_id
    },
    sim_id(state){
      return state.sim_id
    },
    vehicle_category(state){
      return state.vehicle_category
    },
    vehicleCategoryOptions(state){
      return state.vehicleCategoryOptions
    },
    plate_number(state){
      return state.plate_number
    },
    plate_right_letter(state){
      return state.plate_right_letter
    },
    plate_middle_letter(state){
      return state.plate_middle_letter
    },
    plate_left_letter(state){
      return state.plate_left_letter
    }
  }
}
